import { rem } from 'polished'
import styled from 'styled-components'

import media from '../../utils/media'

export const BrandPartnerWrapper = styled.div`
  width: 100%;
  height: 140px;

  ${media.lessThan('xs')`
    height: 120px;
  `}
`

export const BrandPartnerLink = styled.a`
  display: block;
  width: 100%;
  height: 100%;
  transition: all ease 0.4s;
  padding: ${rem(16)};

  &:hover {
    opacity: 0.75;
  }
`

export const BrandPartnerLogo = styled.div`
  width: 100%;
  height: 100%;
  background-image: url(${({ image }) => image});
`
